import round from './round';
import calculatePayment from './calculatePayment';

/**
 * Calculate amortization table for loan
 * @param {Number} loanAmount Total amount of the loan
 * @param {Number} interestRate Interest rate (ex: 9.5)
 * @param {Number} loanLength Length of loan in years
 * @param {Date} startDate Start date of the loan payments. Defaults to today
 * @param {Number} additionalPrincipalPayment Extra principal applied to each monthly payment
 */
export function amortizationCalculator(
  loanAmount,
  interestRate,
  loanLength,
  startDate = new Date(),
  additionalPrincipalPayment = 0
) {
  const monthlyRate = interestRate / 1200.0;
  const numberOfPayments = loanLength * 12.0;
  const monthlyPrincipalAndInterest = round(
    calculatePayment(loanAmount, monthlyRate, numberOfPayments)
  );
  const initialBalance = loanAmount;
  const localDateCopy = new Date(startDate);
  const initialDate = nextMonth(localDateCopy);

  const results = [];

  for (let n = 0; n < numberOfPayments; n++) {
    if (n === 0) {
      const paymentDate = initialDate
        .toLocaleDateString()
        .replace(/[^ -~]/g, '');

      const paymentNumber = n + 1;

      const interestAmount =
        initialBalance * monthlyRate >= monthlyPrincipalAndInterest
          ? round(monthlyPrincipalAndInterest)
          : round(initialBalance * monthlyRate);

      const principalAmount =
        interestAmount < monthlyPrincipalAndInterest
          ? round(
              monthlyPrincipalAndInterest -
                interestAmount +
                additionalPrincipalPayment
            )
          : 0;

      const paymentAmount = round(interestAmount + principalAmount);

      const balance = round(initialBalance - principalAmount);

      results.push({
        paymentDate,
        paymentNumber,
        paymentAmount,
        interestAmount,
        principalAmount,
        balance,
      });
    } else {
      const previous = { ...results[n - 1] };

      const paymentDate = nextMonth(new Date(previous.paymentDate))
        .toLocaleDateString()
        .replace(/[^ -~]/g, '');

      const paymentNumber = n + 1;

      const interestAmount =
        previous.balance * monthlyRate >= monthlyPrincipalAndInterest
          ? round(monthlyPrincipalAndInterest)
          : round(previous.balance * monthlyRate);

      const principalAmount =
        previous.balance >
        monthlyPrincipalAndInterest + additionalPrincipalPayment
          ? interestAmount < monthlyPrincipalAndInterest
            ? round(
                monthlyPrincipalAndInterest -
                  interestAmount +
                  additionalPrincipalPayment
              )
            : 0
          : round(previous.balance);

      const paymentAmount = round(interestAmount + principalAmount);

      const balance = round(previous.balance - principalAmount);

      results.push({
        paymentDate,
        paymentNumber,
        paymentAmount,
        interestAmount,
        principalAmount,
        balance,
      });
    }
  }

  return results;
}

export default amortizationCalculator;

export function nextMonth(date) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + 1);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}
